import React from 'react';


import Adventure from "../Video/Adventure.mp4";
import { Paragraph, Pane } from 'evergreen-ui'
function Adventures(props){
  return (
      <div className="App">
            <video
              autoPlay
              loop
              muted
              style={{
                position: "absolute",
                width: "100%",
                left: "50%",
                top: "50%",
                height: "100%",
                objectFit: "cover",
                transform: "translate(-50%, -50%)",
                zIndex: "-1"
              }}
            >
          <source src ={Adventure} type="video/mp4" />

          </video>
          <Pane clearfix>

          <Pane
          background="transparent"
          elevation={0}
          float="right"
          width={500}
          height={150}
          margin={24}
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          >
          <Paragraph color="black" marginTop="default">
          The Adventure game was created for the purpose of guiding the player in a 3D space through collection. There are coins that the player must collect with a counter telling them how many they have collected and how many more they still need to collect.
          </Paragraph>

          </Pane>
            <Pane
            background="transparent"
            elevation={0}
            float="left"
            width={500}
            height={150}
            margin={300}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
            >
              <Paragraph color="black" marginTop="default">
              The level involves changes in elevation as well as progressively more difficult obstacles leading to the end of the level.  This creates the feeling of accomplishment for the player and makes them feel as though they are getting better at the game as they invest time and obstacles become second nature.
              </Paragraph>

                </Pane>
              </Pane>

          </div>

        );
  };
export default Adventures;
